import React, { useState } from 'react';
import { createPortal } from 'react-dom';
import { ScrollText, X } from 'lucide-react';

const fmt = (n) => Number(n || 0).toLocaleString('pt-BR');
const dataBr = (iso) => (iso ? new Date(iso).toLocaleString('pt-BR', { timeZone: 'America/Sao_Paulo', day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' }) : '—');

// Botão "Regras" (canto direito) + card com as regras do evento, tudo vindo do servidor (state.event)
export const RpRules = ({ event, onOpen, onClose }) => {
  const [open, setOpen] = useState(false);
  const abrir = () => { setOpen(true); onOpen?.(); };
  const fechar = () => { setOpen(false); onClose?.(); };
  const rules = [
    <>A cada <b className="text-amber-300">{fmt(event.coins_per_chest)} moedas</b> compradas você ganha <b>1 baú</b>, até <b className="text-amber-300">{event.max_chests_per_day} baús por dia</b> (dia no horário de Brasília). Ao bater o limite, as moedas a mais do dia não acumulam para baú.</>,
    ...(event.tasks?.length ? [<><b>Tarefas do dia</b> (baú extra, fora do limite): {event.tasks.map((t, i) => <span key={t.task_id}>{i > 0 ? ' · ' : ''}recarregue <b>{t.count}</b> pacotes de <b>{fmt(t.package_coins)}</b> = +{t.reward_chests} baú</span>)}. Só pedidos com o pacote exato contam; o extra só é liberado enquanto houver presente em estoque.</>] : []),
    <>O evento termina em <b>{dataBr(event.ends_at)}</b>. <b className="text-rose-300">Baús não abertos e prêmios não recebidos na live até o término são perdidos.</b> Abra seus baús e receba antes do fim!</>,
    <>Cada baú sorteia <b>1 presente</b> (nunca mais de um) entre os fantasminhas que ainda têm unidade disponível. O sorteio é feito no servidor.</>,
    <>Quando um presente esgota, ele sai do sorteio e fica cinza na lista. Acabando todos, o evento não entrega mais prêmios.</>,
    <>Para receber, toque em <b>"Receber na live"</b>. Com a live aberta você entra na <b>fila de entrega</b>: nossa conta oficial visita <b>uma live por vez</b> (mínimo 15s em cada), dá os parabéns no chat e envia todos os seus prêmios pendentes.</>,
    <><b>Live fechada?</b> Pode clicar mesmo assim: você fica na lista "aguardando live" e, <b>assim que abrir a live no KAKO</b>, detectamos e entregamos automaticamente — <b>desde que o evento ainda esteja no ar</b>.</>,
    <>Cada prêmio é enviado <b>uma única vez</b>. Se a KAKO recusar, ele volta para pendente e você pode tentar receber de novo.</>,
  ];
  return (
    <>
      <button onClick={abrir} data-testid="rp-rules-btn"
        className="flex items-center gap-1 rounded-full border border-amber-300/70 bg-black/45 px-3 py-1 text-xs font-black text-amber-200 backdrop-blur transition-transform active:scale-95">
        <ScrollText className="h-4 w-4" /> Regras
      </button>
      {open && createPortal(
        <div className="fixed inset-0 z-[96] flex items-end justify-center bg-black/80 p-4 backdrop-blur-sm sm:items-center" onClick={fechar} data-testid="rp-rules-overlay">
          <div onClick={(e) => e.stopPropagation()} data-testid="rp-rules-card"
            className="relative w-full max-w-md overflow-hidden rounded-3xl border-2 border-amber-400/70 bg-[#140a2e] shadow-[0_0_50px_rgba(251,191,36,.35)]"
            style={{ backgroundImage: 'linear-gradient(180deg, rgba(20,10,46,.88), rgba(20,10,46,.97)), url(/rp/bg.webp)', backgroundSize: 'cover' }}>
            <button onClick={fechar} data-testid="rp-rules-close" aria-label="Fechar"
              className="absolute right-3 top-3 z-20 flex h-10 w-10 items-center justify-center rounded-full border border-amber-400/60 bg-black/70 text-purple-50 transition-transform active:scale-95"><X className="h-5 w-5" /></button>
            <div className="p-5">
              <img src="/rp/title.webp" alt="Baú Premiado" className="mx-auto w-44" />
              <p className="mt-1 text-center text-[10px] font-black uppercase tracking-[.3em] text-amber-200">Regras do evento</p>
              <ol className="mt-3 max-h-[52vh] space-y-2 overflow-y-auto pr-1 text-[12px] leading-snug text-purple-50">
                {rules.map((r, i) => (
                  <li key={i} className="flex gap-2 rounded-xl bg-white/5 px-3 py-2" data-testid={`rp-rule-${i + 1}`}>
                    <span className="mt-0.5 h-5 w-5 shrink-0 rounded-full bg-amber-300 text-center text-[11px] font-black leading-5 text-black">{i + 1}</span>
                    <span>{r}</span>
                  </li>
                ))}
              </ol>
              <div className="mt-3 grid grid-cols-5 gap-1" data-testid="rp-rules-odds">
                {event.prizes.map((p) => (
                  <div key={p.prop_id} className="rounded-xl bg-black/40 p-1 text-center">
                    <img src={`/rp/${p.prop_id}.png`} alt={p.name} className="mx-auto h-9 w-9 object-contain" />
                    <p className="text-[9px] font-black text-amber-300">🪙{fmt(p.coins)}</p>
                    <p className="text-[9px] text-purple-200">{p.weight}%</p>
                  </div>
                ))}
              </div>
              <p className="mt-2 text-center text-[10px] text-purple-200/70">Chances válidas entre os presentes com unidade disponível. Tudo é validado no servidor.</p>
            </div>
          </div>
        </div>,
        document.body
      )}
    </>
  );
};

export default RpRules;
